import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';

export function RootRedirect() {
  const user = useAuthStore((s) => s.user);

  if (!user) return <Navigate to="/login" replace />;

  // Phase 5.5c·5.5d — admin 이고 MFA 미활성 → /mfa/setup 강제
  if (user.mfa_setup_required) return <Navigate to="/mfa/setup" replace />;

  // 온토 staff/superadmin → /ops/dashboard
  if (user.platform_role === 'staff' || user.platform_role === 'superadmin') {
    return <Navigate to="/ops/dashboard" replace />;
  }

  // org_admin → 자기 primary 조직 화면
  const primaryAdmin = user.orgs.find((o) => o.role === 'org_admin' && o.is_primary);
  const anyAdmin = primaryAdmin ?? user.orgs.find((o) => o.role === 'org_admin');
  if (anyAdmin) {
    return <Navigate to={`/org/${anyAdmin.id}`} replace />;
  }

  // 권한 없음 — portal 로 안내
  return <Navigate to="/no-access" replace />;
}
